import { MultiSelect, MultiSelectItem } from "@amzn/storm-ui-multi-select";
import pluralize from "pluralize";
import React from "react";
import { useStore } from "zustand";

import {
    featureFlagLabelMap,
    FeatureFlags,
    FeatureFlagsStore,
    READY_TO_UAT_FEATURES,
} from "../../store/featureFlags";
import { isDev } from "../../utils/environment.utils";

interface FeatureFlagPickerProps {
    featureFlags: string[];
    setFeatureFlags: (ffs: string[]) => void;
}

export const FeatureFlagPicker: React.FunctionComponent<
    FeatureFlagPickerProps
> = ({ featureFlags, setFeatureFlags }) => {
    const handleChange = (featureFlags: any[]) => {
        setFeatureFlags(featureFlags as string[]);
    };

    const [isAllFeatureFlagsDropDownEnabled] = useStore(
        FeatureFlagsStore,
        (state) => [state.allFeatureFlagsDropDown],
    );

    const featureFlagsToDisplay: FeatureFlags[] =
        isDev() || isAllFeatureFlagsDropDownEnabled
            ? Object.values(FeatureFlags)
            : READY_TO_UAT_FEATURES;

    return (
        <MultiSelect
            fullWidth
            label="Feature Flags"
            name="feature-flag-picker"
            data-testid="feature-flag-picker"
            onChange={handleChange}
            selectedValues={featureFlags}
            selectedLabelOverride={`${pluralize("Flag", featureFlags.length, true)} Selected`}
        >
            {featureFlagsToDisplay.map((ff) => {
                return (
                    <MultiSelectItem
                        key={ff}
                        name={ff}
                        value={ff}
                        data-testid={`${ff}-item`}
                    >
                        {featureFlagLabelMap[ff]}
                    </MultiSelectItem>
                );
            })}
        </MultiSelect>
    );
};
